import { PRODUCT_LIST_SESSION_KEY } from '../constants'
import type { ProductListQuery } from '../types'

/**
 * Mirrors Angular `AuthService.getSessionValue('productlist_filter')` — full list query snapshot.
 */
export function readProductListSessionFilter(): Partial<ProductListQuery> | null {
  try {
    const raw = sessionStorage.getItem(PRODUCT_LIST_SESSION_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as unknown
    if (!parsed || typeof parsed !== 'object') return null
    return parsed as Partial<ProductListQuery>
  } catch {
    return null
  }
}

export function writeProductListSessionFilter(params: ProductListQuery): void {
  try {
    sessionStorage.setItem(PRODUCT_LIST_SESSION_KEY, JSON.stringify(params))
  } catch {
    /* ignore */
  }
}

export function clearProductListSessionFilter(): void {
  try {
    sessionStorage.removeItem(PRODUCT_LIST_SESSION_KEY)
  } catch {
    /* ignore */
  }
}
